const PHP_NUMERIC = /^[+-]?(\d+\.?\d*|\.\d+)(e[+-]?\d+)?$/i;
/** Mirrors scoring's `is_numeric($text) && (int) $text > 0`, so "0.5" does not count. */
export function isGreaterThanZero(text) {
    if (text === null)
        return false;
    const trimmed = text.trim();
    if (!PHP_NUMERIC.test(trimmed))
        return false;
    return Math.trunc(Number(trimmed)) > 0;
}
//# sourceMappingURL=greater-than-zero.js.map